import { useEffect } from "react";
import { useActivatedAccountsData } from "../../../../store/selectors/reportingSelectors";
import { fetchActivatedAccountsThunk } from "../../../../store/thunk/reportingThunk";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../hooks/StoreHooks";
import { AccountCounter, ActivatedAccountsBox, ActivatedAccountsText, ActiveUsersText, TotalUsersText } from "../../Dashboard.styles";
import { PersonIcon } from "../../../../assets/icons/ActionIcons";

const ActivatedAccountsWidget = () => {
    const { t } = useTranslation();
    const activatedAccountsData = useActivatedAccountsData();
    const activeUsers = activatedAccountsData[0]?.active ?? 0;
    const totalUsers = activatedAccountsData[0]?.total ?? 0;
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(fetchActivatedAccountsThunk());
    }, [dispatch]);

    return (
        <ActivatedAccountsBox sx={{ width: "33%" }}>
            <PersonIcon />
            <ActivatedAccountsText>{t("dashboardPage.activatedAccounts")}</ActivatedAccountsText>
            <AccountCounter>
                <ActiveUsersText>{activeUsers}</ActiveUsersText>
                <TotalUsersText> / {totalUsers}</TotalUsersText>
            </AccountCounter>
        </ActivatedAccountsBox>
    )
}

export default ActivatedAccountsWidget